export default __webpack_public_path__ + "static/media/what-we-provide-technicalteam-icon.8b6fcdff.svg";